import React, { Component } from 'react';
import ThomasMainContainer from 'containers/ThomasMainContainter';
import ThomasMainList from 'views/components/ThomasMains/ThomasMainList';

interface IState {
  keyword: string;
  showResults: boolean;
}
class ThomasAdvertiserAddPage extends Component<any, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      keyword: '',
      showResults: false
    };
    //this.handleSearchTerm = this.handleSearchTerm.bind(this);
  }
  handleSearchTerm(e: string) {
    console.log(this.state.keyword);
    if (this.state.keyword.length > 0) {
      this.setState({
        showResults: true
      });
    }
  }
  componentDidMount() {}
  render() {
    return (
      <section>
        <h1 className="page-title">Add new Account</h1>
        <section className="card">
          <h4 className="edit-campaign__title">Search for Account</h4>
          <div className="form-short saturn-input-group">
            <input
              className="form-control form-control-sm search-bar__form saturn-form-control saturn-adv-input"
              type="text"
              name="keywords"
              id="keywords"
              placeholder="Keyword or tgrams_id"
              value={this.state.keyword}
              onChange={e =>
                this.setState({
                  keyword: e.target.value,
                  showResults: false
                })
              }
              size={40}
            />

            <span className="input-group-btn">
              <br />
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => this.handleSearchTerm(this.state.keyword)}
              >
                Continue
              </button>
            </span>
          </div>
          <br />
          <div className="thomas-advertisers__item-body">
            {this.state.showResults && (
              <ThomasMainContainer keyword={this.state.keyword}>
                {({ data }) => <ThomasMainList data={data} />}
              </ThomasMainContainer>
            )}
          </div>
        </section>
      </section>
    );
  }
}

export default ThomasAdvertiserAddPage;
